import React, { useEffect, useState } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import GTCReminder from "../components/GTCReminder";
import { apiRequest, API_CONSTANTS } from "../libs/apiRequest";
import { FaCreditCard, FaHistory, FaTimesCircle } from 'react-icons/fa';
import '../css/gtc-subscription-management.css';

function GTCSubscriptions() {

    const [subscriptions, setSubscriptions] = useState<any[]>([]);
    const [payments, setPayments] = useState<any[]>([]);

    const cancelSubscription = async (subscriptionId: string) => {
        // subscriptionId
        if (window.confirm("Do you want to cancel your plan?")) {
            try {
                const res = await apiRequest({
                    method: "GET",
                    api: API_CONSTANTS.PRIVATE_API,
                    fn: "subscriptioncancel",
                    data: {
                        subscriptionId: subscriptionId
                    }
                })
                if (res && res.status == 200) {
                    alert("Subscription has been canceled.");
                    window.location.reload();
                } else {
                    alert("Something went wrong. Try again later.");
                }
            } catch (error) {
                console.log("cancelSubscription", error);
            }
        }
    }

    const getActiveSubscription = async () => {
        try {
            const res = await apiRequest({
                method: "GET",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "subscriptionactive"
            })
            if (res && res.status == 200) {
                // console.log("getActiveSubscription", res.data)
                setSubscriptions(res.data);
            }
        } catch (error) {
            console.log("getActiveSubscription", error)
        }
    }

    const getPaymentHistory = async () => {
        try {
            const res = await apiRequest({
                method: "GET",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "subscriptionpayments"
            });
            if (res && res.status == 200) {
                // console.log("getPaymentHistory", res.data);
                setPayments(res.data);
            }
        } catch (error) {
            console.log("getPaymentHistory", error);
        }
    }

    useEffect(() => {
        getActiveSubscription();
        getPaymentHistory();
    } , []);


    return (
        <div className="subscription-management">
            <div className="subs-header mb-4">
                <div className="container">
                    <h1 className="subs-title">Subscription Management</h1>
                    <p className="subs-description">
                        Manage your current subscription and billing history
                    </p>
                </div>
            </div>
            <div className="container">
                <GTCReminder 
                    reminder={"Manage your active subscriptions and view payment history"}
                    btnText={"My Channel"}
                />

                <div className="subscription-card">
                    <div className="subscription-header">
                        <FaCreditCard className="header-icon" />
                        <h2 className="subscription-title">Active Subscriptions</h2>
                    </div>
                    <div className="subscription-content">
                        <TableContainer component={Paper} className="custom-table-container">
                            <Table aria-label="subscriptions table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Channel</TableCell>
                                        <TableCell>Service</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Price</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {subscriptions.length > 0 ? (
                                        subscriptions.map((sub, i) => (
                                            <TableRow key={i}>
                                                <TableCell>{sub.data.chanName}</TableCell>
                                                <TableCell>{sub.data.type == "rgeo" ? "Reverse Geocoding" : "IP Geolocation"}</TableCell>
                                                <TableCell>{sub.data.desc}</TableCell>
                                                <TableCell>${sub.data.price}</TableCell>
                                                <TableCell>
                                                    <span className={`subscription-status status-${sub.data.status}`}>
                                                        {sub.data.status}
                                                    </span>
                                                </TableCell>
                                                <TableCell align="right">
                                                    {sub.data.status === "active" && (
                                                        <button 
                                                            className="cancel-button"
                                                            onClick={() => cancelSubscription(sub.key)}
                                                        >
                                                            <FaTimesCircle />
                                                            Cancel
                                                        </button>
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={6}>
                                                <div className="empty-state">
                                                    <FaCreditCard className="empty-icon" />
                                                    <p>No active subscriptions found</p>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>

                <div className="subscription-card">
                    <div className="subscription-header">
                        <FaHistory className="header-icon" />
                        <h2 className="subscription-title">Payment History</h2>
                    </div>
                    <div className="subscription-content">
                        <TableContainer component={Paper} className="custom-table-container">
                            <Table aria-label="payment history table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Channel</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Service</TableCell>
                                        <TableCell>Price</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {payments.length > 0 ? (
                                        payments.map((payment, i) => (
                                            <TableRow key={i}>
                                                <TableCell>{payment.data.chanName || ""}</TableCell>
                                                <TableCell>{payment.data.desc}</TableCell>
                                                <TableCell>{payment.data.type == "rgeo" ? "Reverse Geocoding" : "IP Geolocation"}</TableCell>
                                                <TableCell>${payment.data.price}</TableCell>
                                                <TableCell>
                                                    <span className={`subscription-status status-${payment.data.status}`}>
                                                        {payment.data.status}
                                                    </span>
                                                </TableCell>
                                                <TableCell>
                                                    <span className="payment-date">
                                                        {new Date(payment.data.ts).toLocaleString()}
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={6}>
                                                <div className="empty-state">
                                                    <FaHistory className="empty-icon" />
                                                    <p>No payment history found</p>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GTCSubscriptions;